export enum AbaObrigacoes {
	Todas = 'todasObrigacoes',
	Excluidas = 'excluidas',
}
